<template>
	<form @submit.prevent="save('form-request')"
		autocomplete="off"
		data-vv-scope="form-request" class="template-form">
		<div class="row">
			<div class="col-md-6 mb-17">
				<div class="input-group">
					<label class="template-label">{{configureFields.firstName.chatbotLabelName}}</label><span class="required-symbol"> *</span>
					<input
						type="text"
						class="form-control pt-input input-focus input-value"
						id="firstName"
						:aria-label="(configureFields.firstName && configureFields.firstName.chatbotLabelName) ? configureFields.firstName.chatbotLabelName : 'First name'"
						v-model="ask.first"
						name="first"
						placeholder=""
						v-validate="'required'"
						v-bind:class="{'request-form-error-border': errors.has('form-request.first') }"
						v-focus
						@input="e => ask.first = sanitizeInput(e.target.value)"
					>
					<p
						class="error"
						v-show="errors.has('form-request.first')"
					>{{errors.first('form-request.first')}}</p>
				</div>
			</div>
			<div class="col-md-6 mb-17">
				<div class="input-group">
					<label class="template-label">{{configureFields.lastName.chatbotLabelName}}</label><span class="required-symbol"> *</span>
					<input
						type="text"
						id="lastNAme"
						class="form-control pt-input input-focus input-value"
						:aria-label="(configureFields.lastName && configureFields.lastName.chatbotLabelName) ? configureFields.lastName.chatbotLabelName : 'Last name'"
						v-model="ask.last"
						name="last"
						placeholder=""
						v-validate="'required'"
						v-bind:class="{'request-form-error-border': errors.has('form-request.last') }"
						@input="e => ask.last = sanitizeInput(e.target.value)"
					>
					<p
						class="error"
						v-show="errors.has('form-request.last')"
					>{{errors.first('form-request.last')}}</p>
				</div>
			</div>
			<div class="col-md-6 mb-17">
				<div class="input-group">
					<label class="template-label">{{configureFields.emailAddress.chatbotLabelName}}</label><span class="required-symbol"> *</span>
					<input
						type="text"
						class="form-control pt-input input-focus input-value"
						id="email"
						:aria-label="(configureFields.emailAddress && configureFields.emailAddress.chatbotLabelName) ? configureFields.emailAddress.chatbotLabelName : 'Email address'"
						v-model="ask.email"
						@change="checkMemberStatus"
						name="email"
						placeholder=""
						v-validate.continues="'required|email'"
						v-bind:class="{'request-form-error-border': errors.has('form-request.email') }"
						@input="e => ask.email = sanitizeInput(e.target.value)"
					>
					<p v-show="errors.has('form-request.email')" class="error"
					>{{ errors.first('form-request.email') }}</p>
				</div>
			</div>
			<div class="col-md-6 mb-17" v-if="configureFields.memberRole && configureFields.memberRole.include && configureFields.memberRole.include === true">
				<div class="input-group">
					<label class="template-label">{{memberRole.chatbotLabelName}}</label><span class="required-symbol" v-if="checkAndValidate1('memberRole')"> *</span>
					<select v-validate="`${checkAndValidate1('memberRole')}`" class="form-control pt-input input-focus input-value template-drop-down select-dropdown requestPageDropdown" v-model="dynamicFields.memberRole" name="memberRole">
						<option value="" selected disabled style="display:none">Select role</option>
						<option v-for="role in memberRole.memberValue" :key="role" :value="role.trim()">{{role.trim()}}</option>
					</select>
					<p v-show="errors.has('form-request.memberRole')" class="error">{{ errors.first('form-request.memberRole') }}</p>
				</div>
			</div>
			<div class="col-md-6 mb-17" v-if="configureFields.adviceArea && configureFields.adviceArea.include && configureFields.adviceArea.include === true">
				<div class="input-group" >
					<label class="template-label">{{adviceArea.chatbotLabelName}}</label><span class="required-symbol" v-if="checkAndValidate1('adviceArea')"> *</span>
					<select v-validate="`${checkAndValidate1('adviceArea')}`" class="form-control pt-input input-focus input-value template-drop-down select-dropdown requestPageDropdown" v-model="dynamicFields.adviceArea" name="adviceArea">
						<option value="" selected disabled style="display:none">Select Area</option>
						<option v-for="role in adviceArea.memberValue" :key="role" :value="role.trim()">{{role.trim()}}</option>
					</select>
					<p v-show="errors.has('form-request.adviceArea')" class="error">{{ errors.first('form-request.adviceArea') }}</p>
				</div>
			</div>
			<div class="col-md-6 mb-17" v-if="configureFields.phoneNumber && configureFields.phoneNumber.include && configureFields.phoneNumber.include === true">
				<div class="input-group">
					<label class="template-label">{{configureFields.phoneNumber.chatbotLabelName}}</label><span class="required-symbol" v-if="checkAndValidate1('phoneNumber')"> *</span>
					<input
						type="text"
						class="form-control pt-input input-focus input-value"
						id="phoneNumber"
						v-model="dynamicFields.phoneNumber"
						:aria-label="(configureFields.phoneNumber && configureFields.phoneNumber.chatbotLabelName) ? configureFields.phoneNumber.chatbotLabelName : 'Phone number'"
						name="phoneNumber"
						v-validate.continues="`${checkAndValidate1('phoneNumber')}`"
						v-bind:class="{'request-form-error-border': errors.has('form-request.phoneNumber') }"
						@input="e => dynamicFields.phoneNumber = sanitizeInput(e.target.value)"
					>
					<p v-show="errors.has('form-request.phoneNumber')" class="error">
						{{ errors.first('form-request.phoneNumber') }}
					</p>
				</div>
			</div>
			<div class="col-md-12 mb-17" v-if="configureFields.linkedInProfile && configureFields.linkedInProfile.include && configureFields.linkedInProfile.include === true">
				<div class="input-group">
					<label class="template-label">{{configureFields.linkedInProfile.chatbotLabelName}}</label><span class="required-symbol" v-if="checkAndValidate1('linkedInProfile')"> *</span>
					<input type="text"
						class="form-control pt-input input-focus input-value" v-model="dynamicFields.linkedInProfile" id="linkedInProfile" name="linkedInProfile"  :aria-label="(configureFields.linkedInProfile && configureFields.linkedInProfile.chatbotLabelName) ? configureFields.linkedInProfile.chatbotLabelName : 'LinkedIn URL'" v-bind:class="{'request-form-error-border': errors.has('form-request.linkedInProfile') }" v-validate="{ required: configureFields.linkedInProfile.require == true ? true: false, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }"
						@input="e => dynamicFields.linkedInProfile = sanitizeUrl(e.target.value)">
					<p v-show="errors.has('form-request.linkedInProfile')" class="error">{{ errors.first('form-request.linkedInProfile') }}</p>
				</div>
			</div>
			<div class="col-md-6 mb-17" v-if="configureFields.college && configureFields.college.include && configureFields.college.include === true">
				<div class="input-group">
					<label class="template-label">{{configureFields.college.chatbotLabelName}}</label><span class="required-symbol" v-if="checkAndValidate1('college')"> *</span>
					<input
						type="text"
						class="form-control pt-input input-focus input-value"
						id="college"
						v-model="dynamicFields.college"
						:aria-label="(configureFields.college && configureFields.college.chatbotLabelName) ? configureFields.college.chatbotLabelName : 'College'"
						name="college"
						v-validate.continues="`${checkAndValidate1('college')}`"
						v-bind:class="{'request-form-error-border': errors.has('form-request.college') }"
						@input="e => dynamicFields.college = sanitizeInput(e.target.value)"
					>
					<p
						v-show="errors.has('form-request.college')"
						class="error"
					>{{ errors.first('form-request.college') }}</p>
				</div>
			</div>
			<div class="col-md-6 mb-17" v-if="configureFields.major && configureFields.major.include && configureFields.major.include === true">
				<div class="input-group">
					<label class="template-label" for="major">{{configureFields.major.chatbotLabelName || configureFields.major.labelName}}<span class="required-symbol" v-if="checkAndValidate1('major')"> *</span></label>
					<select
						id="major"
						class="form-control pt-input input-focus input-value template-drop-down select-dropdown requestPageDropdown"
						v-model="selectedMajorTemp"
						name="majorSelect"
						:aria-required="checkAndValidate1('major') ? 'true' : 'false'"
						data-vv-validate-on="change|blur"
						@change="onMajorSelect"
					>
						<option value="" selected disabled style="display:none">Select {{configureFields.major.labelName || 'Major'}}</option>
						<option v-for="(m, idx) in major.memberValue" :key="`major-${idx}`" :value="m.trim()">{{m.trim()}}</option>
					</select>

					<input type="hidden" name="major" :value="majorJoined" v-validate="`${checkAndValidate1('major')}`" data-vv-validate-on="change|blur" :aria-describedby="checkAndValidate1('major') ? 'required-note' : null" />
					<p v-show="errors.has('form-request.major')" class="error">{{ errors.first('form-request.major') }}</p>
					<div v-if="dynamicFields.major && dynamicFields.major.length" class="selected-chips">
						<span v-for="(m, idx) in dynamicFields.major" :key="`major-chip-${m}`" class="chip">{{ m }}
							<button type="button" class="chip-close" :aria-label="'Remove ' + m" @click.stop="removeMajorByValue(m)">×</button>
						</span>
					</div>
				</div>
			</div>
			<div class="col-md-6 mb-17" v-if="configureFields.classYear && configureFields.classYear.include && configureFields.classYear.include === true">
				<div class="input-group ">
					<label class="template-label">{{configureFields.classYear.chatbotLabelName}}</label><span class="required-symbol" v-if="checkAndValidate1('year')"> *</span>
					<input
						type="text"
						class="form-control pt-input input-focus input-value"
						id="year"
						v-model="dynamicFields.year"
						:aria-label="(configureFields.classYear && configureFields.classYear.chatbotLabelName) ? configureFields.classYear.chatbotLabelName : 'Class year'"
						name="year"
						v-validate.continues="`${checkAndValidate1('year')}`"
						v-bind:class="{'request-form-error-border': errors.has('form-request.year') }"
						@input="e => dynamicFields.year = sanitizeInput(e.target.value)"
					>
					<p
						v-show="errors.has('form-request.year')"
						class="error"
					>{{ errors.first('form-request.year') }}</p>
				</div>
			</div>
			<div class="col-md-6 mb-17" v-if="configureFields.title && configureFields.title.include && configureFields.title.include === true">
				<div class="input-group">
					<label class="template-label">{{configureFields.title.chatbotLabelName}}</label><span class="required-symbol" v-if="checkAndValidate1('role')"> *</span>
					<input
						type="text"
						class="form-control pt-input input-focus input-value"
						v-model="dynamicFields.role"
						id="role"
						:aria-label="(configureFields.title && configureFields.title.chatbotLabelName) ? configureFields.title.chatbotLabelName : 'Role'"
						name="role"
						v-validate.continues="`${checkAndValidate1('role')}`"
						v-bind:class="{'request-form-error-border': errors.has('form-request.role') }"
						@input="e => dynamicFields.role = sanitizeInput(e.target.value)"
					>
					<p v-show="errors.has('form-request.role')" class="error">
						{{ errors.first('form-request.role') }}
					</p>
				</div>
			</div>
			<div class="col-md-6 mb-17" v-if="configureFields.organization && configureFields.organization.include && configureFields.organization.include === true">
				<div class="input-group">
					<label class="template-label">{{configureFields.organization.chatbotLabelName}}</label><span class="required-symbol" v-if="checkAndValidate1('organization')"> *</span>
					<input
						type="text"
						class="form-control pt-input input-focus input-value"
						id="organization"
						v-model="dynamicFields.organization"
						:aria-label="(configureFields.organization && configureFields.organization.chatbotLabelName) ? configureFields.organization.chatbotLabelName : 'Organization'"
						name="organization"
						v-validate.continues="`${checkAndValidate1('organization')}`"
						v-bind:class="{'request-form-error-border': errors.has('form-request.organization') }"
						@input="e => dynamicFields.organization = sanitizeInput(e.target.value)"
					>
					<p
						v-show="errors.has('form-request.organization')"
						class="error"
					>{{ errors.first('form-request.organization') }}</p>
				</div>
			</div>
			<div class="col-md-6 mb-17" v-if="configureFields.studentId && configureFields.studentId.include && configureFields.studentId.include === true">
				<div class="input-group">
					<label class="template-label">{{configureFields.studentId.chatbotLabelName}}</label><span class="required-symbol" v-if="checkAndValidate1('studentId')"> *</span>
					<input
						type="text"
						class="form-control pt-input input-focus input-value"
						v-model="dynamicFields.studentId"
						id="studentId"
						:aria-label="(configureFields.studentId && configureFields.studentId.chatbotLabelName) ? configureFields.studentId.chatbotLabelName : 'Student ID'"
						name="studentId"
						v-validate.continues="`${checkAndValidate1('studentId')}`"
						v-bind:class="{'request-form-error-border': errors.has('form-request.studentId') }"
						@input="e => dynamicFields.studentId = sanitizeInput(e.target.value)"
					>
					<p
						v-show="errors.has('form-request.studentId')"
						class="error"
					>{{ errors.first('form-request.studentId') }}</p>
				</div>
			</div>
			<div class="col-md-12 mb-17">
				<div class="input-group">
					<label class="template-label">{{configureFields.subject.chatbotLabelName}}</label><span class="required-symbol"> *</span>
					<input
						type="text"
						class="form-control pt-input w-100 input-focus input-value"
						id="title"
						:placeholder="this.requestForm.subjectLine"
						:aria-label="(configureFields.subject && configureFields.subject.chatbotLabelName) ? configureFields.subject.chatbotLabelName : 'Subject'"
						v-model="ask.subject"
						name="title"
						v-validate="'required'"
						v-bind:class="{'request-form-error-border': errors.has('form-request.title') }"
						@input="e => ask.subject = sanitizeInput(e.target.value)"
					>
					<p
						class="error"
						v-show="errors.has('form-request.title')"
					>{{errors.first('form-request.title')}}</p>
				</div>
			</div>
			<div class="col-md-12" v-if="configureFields.dueDate && configureFields.dueDate.include && configureFields.dueDate.include === true">
				<div class="input-group">
					<label class="template-label">{{configureFields.dueDate.chatbotLabelName}}</label><span class="required-symbol" v-if="checkAndValidate1('dueDate')"> *</span>
					<datepicker id="dueDate" name="dueDate" class="input-focus template-input-date-picker" v-model="dynamicFields.dueDate" v-bind:class="{'request-form-error-border': errors.has('form-request.dueDate') }" :format="DatePickerFormat" :disabledDates="disabledDates" v-validate.continues="`${checkAndValidate1('dueDate')}`"></datepicker>
					<span class="helper-text template-label mb-0-custom"><strong>Note:</strong> Does your request have an expiration date after which an answer is no longer desirable?</span>
					<p
						v-show="errors.has('form-request.dueDate')"
						class="error"
					>{{ errors.first('form-request.dueDate') }}</p>
				</div>
			</div>
			<div class="col-md-12">
				<label class="template-label">{{configureFields.question.chatbotLabelName}}</label><span class="required-symbol"> *</span>
				<div class="input-group pd-remove unsubscribe-height input-focus template-input-text-area">
					<textarea
						class="form-control pt-input request-form-question-textarea"
						id="message"
						:placeholder="this.requestForm.question"
						:aria-label="(configureFields.question && configureFields.question.chatbotLabelName) ? configureFields.question.chatbotLabelName : 'Message'"
						v-model="ask.text"
						name="message"
						:maxlength="max"
						v-validate.continues="'required|max:2000'"
						v-on:keyup="countdown"
						rows="20"
						v-bind:class="{'request-form-error-border': errors.has('form-request.message') }"
						@input="e => ask.text = sanitizeInput(e.target.value)"
					></textarea>
					<div class="form-group pd-remove unsubscribe-btn mb-0-custom">
						<div
							class="char-counter template-subject-counter"
						v-bind:class="{'char-count-error': exceedsMaxCount }"
						>{{remainingCount}}  / 2000</div>
					</div>
				</div>
				<p class="error error-mb--2">
					<span v-for="(error,index) in errors.collect('form-request.message')"
						v-bind:key="index"
					>{{ error }}</span>
				</p>
			</div>
		</div>
		<div class="row mlr0" v-if="configureFields.disclaimer && configureFields.disclaimer.include && configureFields.disclaimer.include === true">
			<div class="form-group disclaimer">
				<md-checkbox name="disclaimer" id="disclaimer" v-model="dynamicFields.disclaimer"
				@change="updateDisclaimer()"
				class="form-control template-checkbox pt-0" v-validate.continues="`${checkAndValidate1('disclaimer')}`"></md-checkbox>
				<label v-html="configureFields.disclaimer.chatbotLabelName" class="html-disclaimer" for="disclaimer"></label>
				<p v-show="errors.has('form-request.disclaimer')" class="error error-mt-2 template-checkbox-error" >{{ errors.first('form-request.disclaimer') }}</p>
			</div>
		</div>
		<div class="template-mb-30" v-if="configureFields.disclaimer && configureFields.disclaimer.include === false"></div>
		<div class="btn-block text-right mlr0">
			<md-button v-bind:style="reviewBtn" type="submit"
					name="unsubscribe"
					class="btn btn_info template-review-submit template-button template-button-width">Review
					</md-button>
		</div>
	</form>
</template>

<!-- Script-->
<script>
import API from "../services/API";
import Member from "./Member";
import Datepicker from 'vuejs-datepicker';
import { sanitizeInput, sanitizeUrl } from '../utils/sanitizer';
import { MajorFieldsMixin } from '../helpers/majorsHelper';

export default {
	mixins: [MajorFieldsMixin],
	components: {
		Member,
		Datepicker
	},
	props: {
		community: {
			required: true
		},
		ask: {
			required: true
		},
		checkMemberStatus: {
			required: true
		}
	},
	data() {
		return {
		api: new API(),
		fullPage: true,
		max: 2000,
		remainingCount: 0,
		message: "",
		isBeforRequest: true,
		exceedsMaxCount: false,
		configureFields: {
			firstName: {
				labelName: ''
			},
			lastName: {
				labelName: ''
			},
			emailAddress: {
				labelName: ''
			},
			subject: {
				labelName: ''
			},
			question: {
				labelName: ''
			}
		},
		dynamicFields: {},
		requestForm: {
			subjectLine: 'Short summary ...',
			question: "I have a question about ..."
		},
		isSubmitForm: false,
			reviewBtn: {
				background: '#9178A0',
				color: '#ffffff'
			},
			DatePickerFormat: "MM/dd/yyyy",
			disabledDates: {
				to: new Date(Date.now() - 8640000)
			},
			askId: '',
			memberRole: {},
			adviceArea: {},
			major: {},
			selectedMajorTemp: ''
		};
	},
  	created: async function() {
		this.dynamicFields = this.ask.dynamicFields;
		var date = new Date();
		var AddDay = date.setDate(date.getDate() + 1);
		this.disabledDates.to = new Date(AddDay - 8640000);
		this.countdown();
		this.loadData();
		const dict = {
			custom: {
				email: {
					required: () => "Please enter your email address",
					email: () => "Please enter a valid email address"
				},
				first: {
					required: () => "Please enter your first name"
				},
				last: {
					required: () => "Please enter your last name"
				},
				title: {
					required: () => "Please enter a subject line"
				},
				message: {
					required: () => "Please enter a question",
					max: () => "Message may not exceed 500 characters"
				},
				college: {
					required: () => "Please enter your college"
				},
				year: {
					required: () => "Please enter your class year"
				},
				role: {
					required: () => "Please enter a title"
				},
				organization: {
					required: () => "Please enter an organization"
				},
				studentId: {
					required: () => "Please enter " + this.configureFields.studentId.chatbotLabelName.toLowerCase()
				},
				dueDate: {
					required: () => "Please enter valid date"
				},
				linkedInProfile: {
					required: () => "Please enter linkedin profile url",
					regex: () => "Please enter valid url"
				},
				phoneNumber: {
					required: () => "Please enter phone number"
				},
				disclaimer: {
					required: () => "Please check the above box."
				},
				memberRole: {
					required: () => "Please select value."
				},
				adviceArea: {
					required: () => "Please select value."
				},
				major: {
					required: () => "Please select your major"
				}
			}
		};
		// or use the instance method
		this.$validator.localize("en", dict);
  	},
	methods: {
		sanitizeInput(input) {
            return sanitizeInput(input);
        },
        sanitizeUrl(url) {
            return sanitizeUrl(url);
        },
    onMajorSelect(e) {
				const val = (this.selectedMajorTemp || '').trim();
				if (!val) return;
				if (!Array.isArray(this.dynamicFields.major)) this.$set(this.dynamicFields, 'major', []);
				if (!this.dynamicFields.major.includes(val)) {
					const next = [...this.dynamicFields.major, val].sort((a, b) => a.localeCompare(b));
					this.$set(this.dynamicFields, 'major', next);
				}
				this.selectedMajorTemp = '';
		},
		removeMajorByValue(value) {
			if (!Array.isArray(this.dynamicFields.major)) return;
			const next = this.dynamicFields.major.filter(v => v !== value);
			this.$set(this.dynamicFields, 'major', next);
		},
		countdown: function() {
			this.remainingCount = this.max - this.ask.text.length;
			this.remainingCount === 0
				? (this.exceedsMaxCount = true)
				: (this.exceedsMaxCount = false);
		},
		loadData: async function() {
			if (this.community.content.requestPageThankYou) {
				const replaceStr = this.community.content.requestPageThankYou.replace(/\n/g, "<br />");
				this.community.content.requestPageThankYou = replaceStr;
			}
			if (this.community.content.requestForm) {
				this.requestForm.subjectLine = this.community.content.requestForm.subjectLine.trim() == '' ? 'Short summary ...' : this.community.content.requestForm.subjectLine.trim();
				this.requestForm.question = this.community.content.requestForm.question.trim() == '' ? "[Click Here to Edit]\nI have a question about ..." : "[Click Here to Edit]\n" + this.community.content.requestForm.question.trim();
			}
			if (this.community.content.configureFields && this.community.content.configureFields.memberRole) {
				this.memberRole = this.community.content.configureFields.memberRole;
				if (this.memberRole.chatbotValue) {
					if (!this.ask.dynamicFields.memberRole) {
						this.dynamicFields.memberRole = '';
					}
					this.memberRole.memberValue = this.memberRole.chatbotValue.split(",");
				}
			}
			if (this.community.content.configureFields && this.community.content.configureFields.adviceArea) {
				this.adviceArea = this.community.content.configureFields.adviceArea;
				if (this.adviceArea.chatbotValue) {
					if (!this.ask.dynamicFields.adviceArea) {
						this.dynamicFields.adviceArea = '';
					}
					this.adviceArea.memberValue = this.adviceArea.chatbotValue.split(",");
				}
			}
			if (this.community.content.configureFields && this.community.content.configureFields.major) {
				this.major = this.community.content.configureFields.major;
				if (this.major.chatbotValue) {
					if (!this.ask.dynamicFields.major) {
						this.$set(this.dynamicFields, 'major', []);
					} else if (typeof this.ask.dynamicFields.major === 'string') {
						this.$set(this.dynamicFields, 'major', this.ask.dynamicFields.major.split(',').map(s => s.trim()).filter(Boolean));
					}
					this.major.memberValue = this.major.chatbotValue.split(",");
				}
			}
			this.reviewBtn = {
				background: this.community.customSettings.primaryBtnBgColor,
				color: this.community.customSettings.primaryTxtColor
			};

			if (this.community.content && this.community.content.configureFields) {
				this.configureFields = this.community.content.configureFields;
			}
			this.$validator.errors.clear();
			this.$validator.reset();
		},
		save: function(scope) {
			this.$validator.validateAll(scope).then(result => {
				if (result) {
					// Clean majors to avoid sending empty or over-limit majors to backend
					this.cleanMajorFields();
					this.$emit('isBeforRequest', false)
				}
			});
		},
		checkAndValidate1(field) {
			var validationRules;
			if (this.configureFields && field === 'college') {
				validationRules = this.configureFields.college && this.configureFields.college.require && this.configureFields.college.require === true ? 'required' : '';
				return validationRules;
			} else if (this.configureFields && field === 'year') {
				validationRules = this.configureFields.classYear && this.configureFields.classYear.require && this.configureFields.classYear.require === true ? 'required' : '';
				return validationRules;
      } else if (this.configureFields && field === 'major') {
				validationRules = this.configureFields.major && this.configureFields.major.require && this.configureFields.major.require === true ? 'required' : '';
				return validationRules;
			} else if (this.configureFields && field === 'role') {
				validationRules = this.configureFields.title && this.configureFields.title.require && this.configureFields.title.require === true ? 'required' : '';
				return validationRules;
			} else if (this.configureFields && field === 'organization') {
				validationRules = this.configureFields.organization && this.configureFields.organization.require && this.configureFields.organization.require === true ? 'required' : '';
				return validationRules;
			} else if (this.configureFields && field === 'studentId') {
				validationRules = this.configureFields.studentId && this.configureFields.studentId.require && this.configureFields.studentId.require === true ? 'required' : '';
				return validationRules;
			} else if (this.configureFields && field === 'dueDate') {
				validationRules = this.configureFields.dueDate && this.configureFields.dueDate.require && this.configureFields.dueDate.require === true ? 'required' : '';
				return validationRules;
			} else if (this.configureFields && field === 'linkedInProfile') {
				validationRules = this.configureFields.linkedInProfile && this.configureFields.linkedInProfile.require && this.configureFields.linkedInProfile.require === true ? 'required' : '';
				return validationRules;
			} else if (this.configureFields && field === 'phoneNumber') {
				validationRules = this.configureFields.phoneNumber && this.configureFields.phoneNumber.require && this.configureFields.phoneNumber.require === true ? 'required' : '';
				return validationRules;
			} else if (this.configureFields && field === 'disclaimer') {
				validationRules = this.configureFields.disclaimer && this.configureFields.disclaimer.require && this.configureFields.disclaimer.require === true ? 'required' : '';
				return validationRules;
			} else if (this.configureFields && field === 'memberRole') {
				validationRules = this.configureFields.memberRole && this.configureFields.memberRole.require && this.configureFields.memberRole.require === true ? 'required' : '';
				return validationRules;
			} else if (this.configureFields && field === 'adviceArea') {
				validationRules = this.configureFields.adviceArea && this.configureFields.adviceArea.require && this.configureFields.adviceArea.require === true ? 'required' : '';
				return validationRules;
			}
		},
		updateDisclaimer: function() {
			if (this.dynamicFields.disclaimer === false && this.configureFields.disclaimer.require && this.configureFields.disclaimer.require === true) {
				this.dynamicFields.disclaimer = undefined;
			}
		}
  	}
};
</script>



// WEBPACK FOOTER //
// src/components/__CommunityRequestForm.vue